import styles from './expert.module.scss';
import { IExpert } from '../../../interfaces/expert.interface';
import defaultImage from '../../../assets/img/default-expert-image.jpg';
import { appConfig } from '../../../config/app.config';
import classNames from 'classnames';
import { Animate } from '../../animation/animation';
import ReactMarkDown from 'react-markdown';
import { Fragment, memo } from 'react';

interface ExpertProps {
  content: IExpert
  theme: string
  active: boolean
  shift?: boolean
}

export const Expert = memo(({content, theme, active, shift }:ExpertProps) => {
  const imageUrl = content.image?.url ? appConfig().assets_url + content.image.url : defaultImage;

	return (
    <Animate animation={'go_down'} when={active} delay={400}>
      <div className={classNames(styles[theme], { [styles.shift]: shift })}>

        <div className={styles.image}>
          <img src={imageUrl} alt=""/>
        </div>

        <div className={styles.textSection}>
          <h3 className={styles.header}>
            <ReactMarkDown 
              source={content.header}
              escapeHtml={false}
              renderers={{ paragraph: props => <Fragment children={props.children}/> }}
            /> 
            <div className={styles.status}>Online</div>
          </h3>
          <p className={styles.description}>
            <ReactMarkDown 
              source={content.description}
              escapeHtml={false}
              renderers={{ paragraph: props => <Fragment children={props.children}/> }}
            /> 
          </p> 
        </div>

      </div>
    </Animate>
	)
});